// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__MKeRJ","title":"BackImages_title__xVm3G","images":"BackImages_images__6NAVn"};